(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function findSectionEl(sectionKey) {
    // Shopify most common wrapper:
    // <div id="shopify-section-SECTION_KEY">
    let el = document.getElementById("shopify-section-" + sectionKey);
    if (el) return el;

    // Some themes replace underscores with dashes
    el = document.getElementById("shopify-section-" + sectionKey.replace(/_/g, "-"));
    if (el) return el;

    // Some themes also dash the middle part
    // (fallback: find any element id containing the key)
    el = document.querySelector('[id*="' + sectionKey + '"]');
    if (el) return el;

    return null;
  }

  ready(function () {
    const wrap = document.querySelector(".am-jump__inner");
    if (!wrap) return;

    const buttons = Array.from(wrap.querySelectorAll(".am-jump__btn"));
    const offset = parseInt(wrap.getAttribute("data-offset") || "0", 10);

    buttons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();

        const key = btn.getAttribute("data-section");
        const target = findSectionEl(key);
        if (!target) return;

        buttons.forEach((b) => b.classList.remove("is-active"));
        btn.classList.add("is-active");

        const y = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: "smooth" });
      });
    });
  });
})();
